let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aUVUi")).then(() => parcelRequire('7S4i0'));